<section class="product-section section">
    <div class="container">
        <div class="section-title">
            <h2>Products</h2>
        </div>
        <div class="product-wrapper">
            <owl-carousel-o [options]="customOptions">
                <!-- <ng-container *ngFor="let product of productArray.productList;"> -->
                <ng-template carouselSlide *ngFor="let product of productArray.productList;">
                    <div class="product-slide">
                        <img [src]="product.img">
                        <div class="product-text">
                            <h3 class="title">{{product.title}}</h3>
                            <p class="description">{{product.description}}</p>
                            <button class="get-quote-btn" (click)="open(mymodal)">Get Quote</button>
                        </div>
                    </div>
                </ng-template>
                <!-- </ng-container> -->
            </owl-carousel-o>
        </div>

    </div>
</section>
<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Contact Form</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <!-- <div class="modal-body">
        <p>{{modaltDescription}}</p>
    </div> -->
    <div class="modal-body">
        <form [formGroup]="FormData" class="rcs-contact-form" (ngSubmit)="sendEmail($event)">
            <div class="form-group">
                <label for="fullname">Name</label>
                <input type="text" class="form-control" name="user_name" placeholder="Enter your name here" formControlName="user_name">
            </div>
            <div class="form-group">
                <label for="Email">Email</label>
                <input type="email" class="form-control" name="user_email" aria-describedby="emailHelp" placeholder="Enter your email here" formControlName="user_email">
                <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
            </div>
            <div class="form-group">
                <label for="fullname">Mobile Number</label>
                <input type="text" class="form-control" name="user_number" placeholder="Enter your mobile number here" formControlName="user_number">
            </div>
            <div class="form-group">
                <label for="fullname">Subject</label>
                <input type="text" class="form-control" name="user_subject" placeholder="Enter your subject here" formControlName="user_subject">
            </div>
            <div class="form-group form-group-textarea">
                <label for="comment">Message</label>
                <textarea class="form-control" formControlName="user_message" name="user_message" placeholder="Enter your message here">
        </textarea>
            </div>
            <button type="submit" class="btn btn-primary submit-btn" [disabled]="!FormData.valid">Submit</button>
            <!-- <label>Name</label>
        <input type="text" name="user_name">
        <label>Mobile Number</label>
        <input type="text" name="user_number">
        <label>Email</label>
        <input type="email" name="user_email">
        <label>Message</label>
        <textarea name="message"></textarea>
        <input type="submit" value="Send"> -->
        </form>
    </div>
    <!-- <div class="modal-footer">
        <button type="button" ngbAutofocus class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button>
    </div> -->
</ng-template>